export type RewriteStateSettings = {
  refresh: boolean;
};

export const defaultSettings: RewriteStateSettings = {
  refresh: true,
};
